import PaymentMethods from './PaymentMethods.component';

export default PaymentMethods;
